// paymentSummeryReducer.js
import { 
    SET_PLAN, SET_ADDONS, SET_TOTAL_PRICE,
    SET_FULL_PRICE, SET_MONTHLY_PRICE, SET_MONTHLY_REPAYMENT, 
    SET_DEPOSIT_PRICE, SET_TOTAL_CHARGE_CREDIT, SET_BROKER_FEE, 
    SET_SELECT_INSURER_TYPE, SET_AI_DEPOSIT_PRICE, SET_AI_MONTHLY_REPAYMENT, SET_AI_FULL_PRICE, SET_AI_MONTHLY_FULL, SET_USER_EMAIL, SET_SELECT_AI_INSURER_TYPE, SET_AI_TOTAL_CHARGE_CREDIT
} from './paymentSummeryActions';

// Initial state
const initialState = {
    plan: [],
    selectedAddons: [],
    totalPrice: 0,
    fullPrice: 0,
    monthlyPrice: 0,
    monthlyRepayment: 0,
    depositPrice: 0,
    totalChargeCredit: 0,
    brokerFee: 0,
    selectInsurerType: '',
    aiDepositPrice: 0,
    aiMonthlyRepayment: 0,
    aitotalPrice: 0,
    aiMonthlyFull: 0,
    userEmail: '',
    selectAiInsurerType: '',
    aitotaChargeCredit: 0
};

// Reducer to handle plan, add-ons, and total price
const paymentSummeryReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_PLAN:
            return {
                ...state,
                plan: action.payload
            };
        case SET_ADDONS:
            return {
                ...state,
                selectedAddons: action.payload
            };
        case SET_TOTAL_PRICE:
            return {
                ...state,
                totalPrice: action.payload
            };
        case SET_FULL_PRICE:
            return {
                ...state,
                fullPrice: action.payload
            };
        case SET_MONTHLY_PRICE:
            return {
                ...state,
                monthlyPrice: action.payload
            };
        case SET_MONTHLY_REPAYMENT:
            return {
                ...state,
                monthlyRepayment: action.payload
            };
        case SET_DEPOSIT_PRICE:
            return {
                ...state,
                depositPrice: action.payload
            };
        case SET_TOTAL_CHARGE_CREDIT:
            return {
                ...state,
                totalChargeCredit: action.payload
            };
        case SET_BROKER_FEE:
            return {
                ...state,
                brokerFee: action.payload
            };
        case SET_SELECT_INSURER_TYPE:
            return {
                ...state,
                selectInsurerType: action.payload
            };
        case SET_AI_DEPOSIT_PRICE:
            return {
                ...state,
                aiDepositPrice: action.payload
            };
        case SET_AI_MONTHLY_REPAYMENT:
            return {
                ...state,
                aiMonthlyRepayment: action.payload
            };
        case SET_AI_FULL_PRICE:
            return {
                ...state,
                aitotalPrice: action.payload
            }
        case SET_AI_MONTHLY_FULL:
            return {
                ...state,
                aiMonthlyFull: action.payload
            };
        case SET_USER_EMAIL:
            return {
                ...state,
                userEmail: action.payload
            };
        case SET_AI_TOTAL_CHARGE_CREDIT:
            return {
                ...state,
                aitotaChargeCredit: action.payload
            };
        case SET_SELECT_AI_INSURER_TYPE:
            return {
                ...state,
                selectAiInsurerType: action.payload
            };
        default:
            return state;
    }
};

export default paymentSummeryReducer;